declare const CONFIG_API_URL: string;

export const API_URL = CONFIG_API_URL;
export const GRAPHQL_URL = `${API_URL}/graphql`;

export function isDev(): boolean {
  return new URLSearchParams(location.search).get('dev') === 'true';
}
